import { Module, Mutation, Action, VuexModule } from "vuex-module-decorators";
import { API_ROUTES } from "@/utils/API";
import axios from "@/plugins/http";
import {
  API_TActivity_Log,
  API_TNote,
  TNote_Table,
  convertNotesForTable,
} from "@/models/case_notes";

@Module({ name: "MActivityLog", namespaced: true })
export default class MActivityLog extends VuexModule {
  notes: TNote_Table[] = [];
  count = 0;

  @Mutation
  setNotes(notes: API_TNote[]) {
    this.notes = notes.map((note) => convertNotesForTable(note));
  }

  @Mutation
  setNotesCount(payload: number) {
    this.count = payload;
  }

  @Action
  async fetchtNotes(caseId: number) {
    if (!caseId) return console.log("fetchtNotes error:", "no caseId");

    try {
      const { data } = await axios.get<API_TActivity_Log>(API_ROUTES.CASE_ACTIVITY_LOG(caseId));

      if (!data) return;

      this.context.commit("setNotes", data.items);
      this.context.commit("setNotesCount", data.count);
    } catch (e) {
      console.log("fetchtNotes error:", e);
    }
  }
}
